<template>
  <div class="absolute fill-height invitation-page"  :style="{'background-image': `url(${MainBg})`}">
  </div>
</template>

<script>
import MainBg from '@/assets/img/main-bg.jpg'

export default {
  name: 'InvitationSaraWongPage',
  props: {
    name: {
      type: String,
      required: false
    }
  },

  mounted () {
    this.$root.userPassedThroughInvitation = true
    localStorage.setItem('userPassedThroughInvitation', true)
    this.$router.replace({ name: 'InitiativesDetails', params: { slug: 'sara-wong' } })
  },
  destroyed () {
    this.$root.soundManager.unmute('content')
  },

  data () {
    return {
      MainBg
    }
  },
  metaInfo () {
    return {
      // home page browser title
      title: this.$root.siteSettings.invitationWelcomeText
    }
  }
}
</script>

<style lang="scss" scoped>
.invitation-page {
  overflow: hidden;
  background-size: cover;
  background-attachment: fixed;
}

.absolute {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

</style>
